import { Dialog } from 'primereact/dialog';
import { FundGetData } from '~/api/def/endpoints/fundEndpoint';
import { useState } from 'react';
import { TabPanel, TabView } from 'primereact/tabview';
import { FundCostForm } from './FundCostForm';
import { FundValuationEventSection } from '../pages/analyticsDashboard/fundCharts/FundValuationEventSection';

export type FundSettingsDialogProps = {
  onHide: () => void;
  isVisible: boolean;
  selectedFund: FundGetData;
  refetchFundListAnalytics: () => void;
};
export const FundSettingsDialog = ({
  onHide,
  isVisible,
  selectedFund,
  refetchFundListAnalytics,
}: FundSettingsDialogProps) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleCloseDialog = () => {
    onHide();
  };

  return (
    <Dialog
      headerClassName="pt-3"
      header="Fund settings"
      headerStyle={{
        padding: '2rem',
      }}
      visible={isVisible}
      onHide={() => {
        if (!isVisible) return;
        handleCloseDialog();
      }}
      pt={{
        header: {
          style: {
            padding: '1rem',
          },
        },
        content: {
          style: {
            width: '65rem',
            padding: '0rem',
          },
        },
      }}
    >
      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
        pt={{
          navContainer: {
            style: {
              padding: '1rem',
            },
          },
          root: {
            style: {
              height: '100%',
            },
          },
          panelContainer: {
            style: {
              height: '100%',
              padding: '0rem',
            },
          },
        }}
      >
        <TabPanel header="Cost Config">
          <FundCostForm
            selectedFund={selectedFund}
            refetchFundListAnalytics={refetchFundListAnalytics}
            onHide={onHide}
          />
        </TabPanel>
        <TabPanel header="Dry Powder">
          <FundValuationEventSection
            selectedFund={selectedFund}
            refetchFundListAnalytics={refetchFundListAnalytics}
            onHide={onHide}
          />
        </TabPanel>
      </TabView>
    </Dialog>
  );
};
